export default "__VITE_ASSET__66215072__"